<template>
  <div class="role_warp">
    <div class="item_warp">
       <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-top: 10px"
        @click="select()"
        >筛选</el-button
      >
      </div>
    <!-- 头部工具栏 -->
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">理财ID</label>
        <el-input
          v-model="investId"
          placeholder="请输入理财ID"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">用户</label>
        <el-input
          v-model="uid"
          placeholder="请输入用户uid"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">ip</label>
        <el-input
          v-model="ip"
          placeholder="请输入ip"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">国家地区</label>
        <el-input
          v-model="ipAddress"
          placeholder="请输入国家地区"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">业务员</label>
        <el-select v-model="isYewu" placeholder="请选择" style="width: 120px" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">{{'购买金额 >'}}</label>
        <el-input
          v-model="minPrice"
          placeholder="请输入购买金额"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">{{'购买金额 <'}}</label>
        <el-input
          v-model="maxPrice"
          placeholder="请输入购买金额"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">是否已出售</label>
        <el-select v-model="isSale" placeholder="请选择" style="width: 120px" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      
      
      <div class="item_warp">
        <label style="margin: 0 10px"></label>
        <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1061px"
      size="mini"
    >
      <el-table-column prop="investId" label="用户" width="100">
        <template slot-scope="scoped">
          <div>{{scoped.row.memberUid}}</div>
          <div v-if="scoped.row.isYewu" style="color:red">业务员</div>
        </template>
      </el-table-column>
      <el-table-column prop="yfUsername" label="乙方" width="100" />
      <el-table-column prop="receiveDate" label="理财周期" width="170">
        <template slot-scope="scoped">
          <div>{{scoped.row.financialDay}}天</div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="已购买金额" width="100" />
      <el-table-column prop="investId" label="状态" width="100">
        <template slot-scope="scoped">
          <div v-if="scoped.row.status == 0" style="color:#ADADAD">进行中</div>
          <div v-if="scoped.row.status == 1" style="color:#06CC00">已赎回</div>
        </template>
      </el-table-column>
      <el-table-column prop="toSaleDate" label="赎回时间" width="170">
        <template slot-scope="scoped">
          <div v-if="scoped.row.toSaleDate">{{happenTimeFun1(scoped.row.toSaleDate)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="investId" label="ip" width="120">
        <template slot-scope="scoped">
          <div>{{scoped.row.ip}}</div>
          <div>{{scoped.row.ipAddress}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="buyDate" label="购买时间" width="170">
        <template slot-scope="scoped">
          <div v-if="scoped.row.createDate">{{happenTimeFun1(scoped.row.createDate)}}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加载
      dataTime: ["", ""],
      startDate: "",
      endDate: "",
      investId: "",
      uid: "",
      ip: "",
      ipAddress: "",
      isYewu: "",
      minPrice: "",
      maxPrice: "",
      status: "",
      isSale: "",
    };
  },
  created() {
  },
  mounted() {
    this.getRoleinfo();
  },
  methods: {
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d;
    },
    happenTimeFun1(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getRoleinfo();
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        investId: this.investId,
        uid: this.uid,
        ip: this.ip,
        ipAddress: this.ipAddress,
        isYewu: this.isYewu,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        isSale: this.isSale
      };
      if(this.dataTime[0]){
        params.buyDateStart = this.dataTime[0]
      }
      if(this.dataTime[1]){
        params.buyDateEnd = this.dataTime[1]
      }
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .investRecordList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
